import dayjs from 'dayjs/esm';
import isSameOrAfter from 'dayjs/esm/plugin/isSameOrAfter';
import localeData from 'dayjs/esm/plugin/localeData';
import updateLocale from 'dayjs/esm/plugin/updateLocale';

dayjs.extend(isSameOrAfter);
dayjs.extend(localeData);
dayjs.extend(updateLocale);

export default dayjs;
